// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"3cc321d7","132":"1ee7ffc2","295":"01cf39dd","296":"74901691","297":"fd76944d","488":"13907086","574":"e34addba","698":"2763eedb","950":"74f99349"}[chunkId] + ".chunk.js";
};